import { useTheme , Box, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { GridMain } from "../../components";
import { CarouselCardRestyle } from "../../components/CarouselCardRestyle/CarouselCardRestyle.component";
import { StyledIcon } from "../../components/Video/Video.styles";
import { STATUS_LO } from "../../consts";
//import { useType } from "../../hooks";
import { CardsBox } from "../../routes/Category/Category.styles";
import { StyledButtonLink } from "../../routes/NotFound/NotFound.styles";
import { useAuthStore, useLanguageStore } from "../../stores";
import type {  ReferencedLearningActivity } from "../../types";
import { createEndDate, createStartDate } from "../../utils/general";




export function ActivitiesDetailPage(){
  const { state: routerState } = useLocation();
  const contentActivities = routerState?.contentActivities  as ReferencedLearningActivity[];
  const title = routerState?.title ?? "" as string;
  const language = useLanguageStore(state => state.language)?.id ?? "it";
  const areCardsEnabled = routerState?.areCardsEnabled;
  const theme = useTheme();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const setSpinnerLoginVisible = useAuthStore(state => state.setSpinnerLoginVisible);
  setSpinnerLoginVisible(false);

  return (
    <>
      <GridMain>
        <Box
          sx={ { padding: "1rem" } }
        >
          <StyledButtonLink
            aria-label= { t("explore_back") }
            onClick={ ()=> { navigate(-1) } }
            sx={ { padding:0 } }
          >
            <StyledIcon
              icon={ "arrow_left" }
              height={ "19px" }
              width={ "24px" }
            />
            { t("explore_back") }
          </StyledButtonLink>
          <Typography
            variant={ "h1" }
            fontSize={ "2.125rem" }
            fontWeight={ "700" }
            lineHeight={ "1.235" }
            paddingTop={ "32px" }
            sx={ {
              [theme.breakpoints.down("sm")]: {
                fontSize: "1.5rem",
                marginBottom: "16px",
                paddingLeft: "0",
                paddingRight: "0"
              }
            } }
          >
            { title }
          </Typography>
        </Box>

        <Stack
          maxWidth="calc(100vw - (100vw - 100%))"
          minWidth={ "100%" }
        >
          <CardsBox
            $isLoading={ false }
            sx={ {
              [theme.breakpoints.down("sm")]:{
                gridTemplateColumns: "auto"
              }
            } }
          >
            {
              contentActivities?.map((element,index) => (
              
                <CarouselCardRestyle
                  key={ `tab-content-activities-${index}--${language}` }
                  booked={ element.status !== STATUS_LO.N && element.status !== STATUS_LO.T }
                  categories={ element.topicTags || [] }
                  courseId={ element.courseId ?? routerState?.courseId }
                  coverPublicURL={ element?.coverPublicURL }
                  coverVideoPublicURL={ element?.coverVideoPublicURL }
                  disabled={ !element.isEnable || areCardsEnabled }
                  duration={ element.duration }  
                  ecmRegistration={ element.ecmRegistration }
                  ecm_specialization={ element.ecm_specialization }
                  endDate={ createEndDate(element)  }
                  enrollType={ element.enrollType }
                  expirationDate={ element.expirationDate }
                  id={ element.id }
                  isAutoSubscribeEnable={ element.isAutoSubscribeEnable }
                  isFavourite={ element.isFavourite }
                  isSurvey={ element.isSurvey }
                  isStandAlone={ element.isStandAlone }
                  isTest={ element.isTest }
                  isToj={ false }

                  isEditorial={ element.isEditorial }
                  learningObjectType={ element.learningObjectType }
                  learningObjectTypology={ element.learningObjectTypology }
                  parentId={ element?.parentId ?? undefined } 
                  percentageOfCompletion={ element.percentageOfCompletion }
                  rootId={ routerState?.rootId  }
                  shortDescription={ element.shortDescription }
                  startDate={ createStartDate(element)  }
                  status={ element.status || "N" }
                  small={ true }
                  title={ element.title }
                  canAccessNow={ element.canAccessNow }
                  isLinkRelative={ element.isLinkRelative }
                  link={ element.link }
                  attributes={ element?.attributes }
                  isMandatory={ element.isMandatory }
                  externalFileUrl={ element?.externalFileUrl }
                  isCarouselView={ false }
                />
              ))
            }
          </CardsBox>


        </Stack>
      </GridMain>
    </>

  );
}
